import { action } from 'satcheljs';

/**
 * Called when there is a change in the event duration dropdown
 */

let selectEventDuration = action('selectEventDuration', (defaultEventDuration: number) => ({
    defaultEventDuration,
}));

export default selectEventDuration;
